import { Typography } from '@repo/ui';
import c from 'classnames';
import { ReactNode } from 'react';

import styles from './Badge.module.css';

export type BadgeState = 'good' | 'ok' | 'bad' | 'new' | 'default' | 'tinyPlus';

interface BadgeProps {
  title: ReactNode;
  state?: BadgeState;
  // Escape hatch for per-usage styling (spacing, custom color, size, ...).
  className?: string;
  size?: 'md' | 'sm';
  testId?: string;
}

const sizeMap: Record<
  NonNullable<BadgeProps['size']>,
  Parameters<typeof Typography>[0]['variant']
> = {
  md: 'label',
  sm: 'body-xs',
};

export const Badge = ({
  title,
  state = 'default',
  className,
  size = 'md',
  testId,
}: BadgeProps) => {
  return (
    <div
      className={c(
        styles.wrapper,
        styles[state] ?? styles.default,
        styles[size],
        className,
      )}
      data-testid={testId}
    >
      <Typography variant={sizeMap[size]} className={styles.title}>
        {title}
      </Typography>
    </div>
  );
};
